import React from 'react';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { caDetails } from '../type'
import { CaStatusNames, MyDashboardCA } from '../../../utils/typeConstants';


interface CaDashboardProps {
    dashboardData: any,
    setActiveIndex?: (e: number) => void,
    setSelectedEmployee: (e: caDetails | undefined) => void;
    setVia?: (e: string) => void;
    fromPage?: string;
}

export const MyDashboardTable = (props: CaDashboardProps) => {
    const actionTemplate = (rowData: any) => {

        if (rowData !== null) {
            if (props.fromPage === 'scorecardDashboard' ||props.fromPage === 'CaDashboard' ) {
                return (
                    <Button
                        type="button"
                        icon={rowData.ca_status_name === CaStatusNames.Release ? "pi pi-pencil" : "pi pi-eye"}
                        onClick={() => {
                            props.setSelectedEmployee(rowData)
                            props.setActiveIndex?.(MyDashboardCA.Acknowledged)
                            props.setVia?.('button')
                        }}
                    />
                );
            } 
        }

        return (<div />)
    };
    return (
        <DataTable
            value={props.dashboardData}
            className="ca-dashboard"
            rows={5}
            scrollable
            paginator={props.dashboardData?.length > 5}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[5, 10, 25, 50]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
            <Column
                header="Creation Date"
                field="create_date"
                sortable
                sortField="create_date"
                body={(date) => date.create_date ? DateTemplate(date?.create_date) : '--'}
            />
            <Column
                header="Author"
                field="author_employee_name"
                sortable
                sortField="author_employee_name"
            />
            <Column
                header="Category"
                field="ca_category_name"
                sortable
                sortField="ca_category_name"
            />
            <Column
                header="Severity Level"
                field="severity_level_name"
                sortable
                sortField="severity_level_name"
            />
            <Column
                header="Status"
                field="ca_status_name"
                sortable
                sortField="ca_status_name"
            />

            <Column
                body={(data) => actionTemplate(data)} frozen alignFrozen='right'
            />
        </DataTable>
    )
}